import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentList = () => {
  return (
    <g>
      <path d="m2.05 0 11.901.017c.58.001 1.049.47 1.049 1.05V14.95c0 .58-.47 1.05-1.05 1.05H2.05C1.47 16 1 15.53 1 14.95V1.05C1 .47 1.47 0 2.05 0zm.45 1.501V14.5h11V1.516l-11-.015zM5.25 10.5a.75.75 0 1 1 0 1.5h-.5a.75.75 0 1 1 0-1.5h.5zm6 0a.75.75 0 1 1 0 1.5h-3.5a.75.75 0 1 1 0-1.5h3.5zm-6-3.25a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5h.5zm6 0a.75.75 0 1 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5h3.5zM5.25 4a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5h.5zm6 0a.75.75 0 1 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5h3.5z" />
    </g>
  );
};

export default withIcon(IconDocumentList);
